import '@css/style.scss';

import axios from "axios";
import { MaskInput } from "maska";
import { gsap } from "gsap";   
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Splide from '@splidejs/splide';

gsap.registerPlugin(ScrollTrigger);

/* animate numbers */
// function numberWithCommas(x) {
//     return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// }

// let animatedNumberElements = document.querySelectorAll(".js-animated-number");
// if (animatedNumberElements.length > 0) {
    // const timeline = gsap.timeline({ scrollTrigger: '.mission' });

    // animatedNumberElements.forEach(element => {
    //     gsap.from(element, {
    //         scrollTrigger: '.mission',
    //         textContent: 1,
    //         delay: 0,
    //         duration: 1,
    //         ease: "power1.in",
    //         snap: { textContent: 1 },
    //         stagger: {
    //             each: 1.0,
    //             onUpdate: function() {
    //             this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
    //             },
    //         }
    //     });
    // });

    // gsap.from(
    //     animatedNumberElement,
    //     {
    //         scrollTrigger: ".js-animated-number",
    //         textContent: 0,
    //         duration: 2,
    //         ease: "power1.in",
    //         snap: { textContent: 1 },
    //         stagger: {
    //             each: 1.0,
    //             onUpdate: function() {
    //             this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
    //             },
    //         }
    //     }
    // );
// }

// const teamTrigger = ScrollTrigger.create({
//     trigger: ".team",
//     pin: true,
//     start: "top top",
//     end: "+=300%",
//   });
let teamGridElement = document.querySelector('.team__grid');
if (teamGridElement instanceof HTMLElement) {
    const timeline = gsap.timeline({ scrollTrigger: '.team__grid' });
    document.querySelectorAll(".team__card").forEach((teamCard)=>{
        timeline.from(teamCard, {
            duration: 0.15,
            delay: 0.1,
            opacity: 0,
            ease: "power1.in",
        });
    });
}

const mainTitle = document.querySelector('.hero__title');
if (mainTitle instanceof HTMLElement) {
    gsap.from(mainTitle, { 
        scale: 0.75,
        y: -100,
        opacity: 0,
        duration: 2,
        stagger: 0.2
    });
    console.log('animated main title')
} else {
    console.log('not finded main title')
}

const animatedCircleTop = document.querySelector('.js-animated-circle-top');
if ( animatedCircleTop ) {
    gsap.from(animatedCircleTop, { 
        scrollTrigger: ".mission__title",
        scale: 0.75,
        y: -100,
        opacity: 0,
        duration: 1,
        stagger: 0.2
    });
    console.log('animated main title')
} else {
    console.log('not finded main title')
}

// document.querySelectorAll('.js-industries__section-card').forEach(section => {
//     gsap.from(section, { 
//         scrollTrigger: {
//             trigger: section,
//             start: "top 80%",   // when the top of the trigger hits the top of the viewport
//             end: "+=300",       // end after scrolling 500px beyond the start
//             scrub: true,
//         },
//         scale: 0.75,
//         opacity: 0.75,
//         x: -50,
//         y: -50,
//         ease: "sine.inOut",
//         transformOrigin: "left bottom",
//     });
// });

/* rotate logo */
// gsap.set('#green', {xPercent:-50});
// gsap.timeline({
//   scrollTrigger:{
//     trigger: "#wrap",
//     pin: true,
//     scrub:0.2,
//     start: 'top top',
//     end:'+=10000',
//   }
// })
// .to('#green', {
//   rotation:360*5,
//   duration:1, ease:'none',
// })

/* stiky header */
let header = document.getElementById('header');
let hero = document.getElementById('hero');
if (header) {
    let gameChangerPosition = 1;
    // trigger after last hero section pixels
    if (hero instanceof HTMLElement) {
        let box = hero.getBoundingClientRect();
        gameChangerPosition = box.height - ( box.height / 4 );
    }

    ['scroll', 'resize'].forEach(function(e){
        window.addEventListener(e, function() {
            header.classList.toggle('header--sticky', window.scrollY > gameChangerPosition);
        }, false);
    });

    // initial check
    window.dispatchEvent( new Event("resize") );
    console.log('founded')
} else {
    console.log('No header founded')
}

/* nav area */
function toggleNavigation(){
    let toggler = document.querySelector('.nav-toggler');
    let togglerArea = document.querySelector('.nav-area');
    if (toggler instanceof HTMLElement && togglerArea instanceof HTMLElement ) {
        toggler.classList.toggle('nav-toggler--toggled');
        togglerArea.classList.toggle('nav-area--toggled');
    }
}
function closeNavigation(){
    let toggler = document.querySelector('.nav-toggler');
    let togglerArea = document.querySelector('.nav-area');
    if (toggler instanceof HTMLElement && togglerArea instanceof HTMLElement ) {
        toggler.classList.remove('nav-toggler--toggled');
        togglerArea.classList.remove('nav-area--toggled');
    }
}
let toggler = document.querySelector('.nav-toggler');
if (toggler instanceof HTMLElement) {
    toggler.addEventListener('click', function(event) {
        toggleNavigation();
    }, false);
}


/* spoiler */
let spoiler = document.querySelector('.js-spoiler');
if (spoiler) {
    let plus = spoiler.querySelector('.spoiler__plus');
    let content = spoiler.querySelector('.spoiler__content');
    plus.addEventListener('click', function(event) {
        plus.classList.toggle('spoiler__plus--toggled');
        content.classList.toggle('spoiler__content--toggled');
    }, false);
}

/* smooth navigation */
function scrollToElement( element = null, hash = '', offset = 0 ) {
    if (!(element instanceof HTMLElement) && hash.length > 2 && hash.indexOf('#') >= 0) {
      element = document.querySelector( hash );
    }
    if ( element && element instanceof HTMLElement ) {
      let y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({top: y, behavior: 'smooth'});
    } else {
      console.log('Element: %o, Hash: %s', element, hash);
    }
}
document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function(event){
        closeNavigation();
        event.preventDefault();
        scrollToElement(null, link.hash, 106);
    });
});

document.addEventListener('DOMContentLoaded', event => {
    if (window.location.hash) {
        scrollToElement(null, window.location.hash, 120);
    }
});

/* rotate on scroll*/
// let rotated = document.querySelector('.js-rotated-element');
// if (rotated instanceof HTMLElement) {
//     window.addEventListener('scroll', ()=> {
//         (function recurse() {
//             const lastScrollPosition = window.scrollY;
//             rotated.style.setProperty("--rotation-deg", lastScrollPosition);
//             requestAnimationFrame(recurse);
//         })();
//     });
// }

let closest = function (el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if (matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
}

document.querySelectorAll('.file-input').forEach(fileInput => {
    var cssSelected = 'file-input-selected';
    var elErrorDesc = '.file-input-error-description';
    var elFileWrap = '.fg-file';
    
    fileInput.addEventListener('change', e => {
        let fileName = fileInput.value.split('\\').pop();
        let fileGroup = closest(fileInput, '.fg-file');
        console.log(fileGroup, fileGroup);
        if (fileGroup instanceof HTMLElement) {
            if (fileName.length) {
                fileGroup.classList.add(cssSelected);
            } else {
                fileGroup.classList.remove(cssSelected);
            }

            let fileDescription = fileGroup.querySelector('.fg-file-name > span');
            if (fileDescription instanceof HTMLElement) {
                fileDescription.textContent = fileName;
            }

            let errorElements = fileGroup.querySelectorAll(elErrorDesc);
            if (!errorElements.length) {
                errorElements.forEach(eE => eE.remove());
            }
        }
    });
});

if (MaskInput) {
    let dateField = document.querySelector('input[name="birthday"]');
    if (dateField instanceof HTMLElement) {
        new MaskInput(dateField, { mask: "##/##/####" });
    }
}

document.addEventListener('DOMContentLoaded', event => {
    document.querySelectorAll('form').forEach( (form) => {
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            let formdata = new FormData( form );
            let submitBtn = form.querySelector('[type="submit"]');
            let errorsField = form.querySelector('.errors');
            let successField = form.querySelector('.success');

            let prevText = submitBtn.textContent;
            submitBtn.setAttribute('disabled', true);
            submitBtn.textContent = 'Processing ...';
            if (errorsField instanceof HTMLElement) {
                errorsField.innerHTML = '';
            }
            if (successField instanceof HTMLElement) {
                successField.innerHTML = '';
            }

            window.setTimeout(function(){
                axios.post('/ajax-crm', formdata, {
                    headers: { "Content-Type": "multipart/form-data" }
                })
                .then(function (response) {
                    if (response.data && response.data.response == 'success') {
                        submitBtn.removeAttribute('disabled');
                        form.querySelectorAll('textarea:not([hidden]), input:not([hidden])').forEach(inputElement => {
                            if (inputElement.value) {
                                inputElement.value = '';
                            }
                        });
                        successField.innerHTML = response.data.message;
                        window.setTimeout(function(){
                            successField.innerHTML = '';
                        }, 5000);
                        
                    } else {
                        throw response;
                    }
                })
                .catch(function (response) {
                    if ( response.data ){
                        submitBtn.removeAttribute('disabled');
                        submitBtn.textContent = prevText;
                        
                        if (errorsField instanceof HTMLElement && response.data.response == 'error') {
                            errorsField.innerHTML = response.data.message;
                        }
                    }
                })
                .finally(() => {
                    submitBtn.removeAttribute('disabled');
                    submitBtn.textContent = prevText;
                })
            }, 1500);
    
        })
    });

    // TEAM TRIPLE PENETR... CAROUSEL + SLIDER + NAV
    let teamImgContainer = document.querySelector('#team-img-slider.splide');
    let teamTextContainer = document.querySelector('#team-text-slider.splide');
    let teamNavContainer = document.querySelector('#team-nav-carousel.splide');
    if ( Splide ) {
        if (teamImgContainer instanceof HTMLElement && teamTextContainer instanceof HTMLElement && teamNavContainer instanceof HTMLElement) {

            var teamImgSlider = new Splide( teamImgContainer, {
                type      : 'fade',
                rewind    : true,
                pagination: false,
                arrows    : false,
                fixedWidth  : 438,
                fixedHeight : 438,
                breakpoints : {
                    767: {
                        fixedWidth  : '100%',
                    },
                    576: {
                        fixedHeight  : 310,
                    }
                },
             });

            var teamTextSlider = new Splide( teamTextContainer, {
                type      : 'fade',
                rewind    : true,
                pagination: false,
                arrows    : true,
            });

            var teamNavCarousel = new Splide( teamNavContainer, {
                fixedWidth  : 70,
                fixedHeight : 70,
                gap         : 0,
                rewind      : true,
                pagination  : false,
                isNavigation: true,
                arrows    : false,
                drag: false,
                breakpoints : {
                  767: {
                    fixedWidth : 60,
                    fixedHeight: 60,
                  },
                },
              } );


              teamImgSlider.sync( teamTextSlider );
              teamTextSlider.sync( teamNavCarousel );

              let navData = teamTextContainer.querySelector( '.nav-data' );
              if (navData instanceof HTMLElement) {
                  let navDataLeft = navData.querySelector('.nav-data-left');
                  let navDataRight = navData.querySelector('.nav-data-right');
                  if (navDataLeft instanceof HTMLElement && navDataRight instanceof HTMLElement) {
                      // Updates the bar width whenever the carousel moves:
                      teamTextSlider.on( 'mounted', function () {
                        navDataRight.textContent = teamTextSlider.Components.Controller.getEnd() + 1;
                        navDataLeft.textContent = teamTextSlider.Components.Controller.getIndex() + 1;
                      });
                      teamTextSlider.on( 'move', function () {
                        navDataLeft.textContent = teamTextSlider.Components.Controller.getIndex() + 1;
                      });
                  }
              }



              teamImgSlider.mount();
              teamTextSlider.mount();
              teamNavCarousel.mount();

        }
    }

})
// transform: rotate( calc(var(--transform) / 6 * 1deg));
// transition: transform 1.25s ease-out;

/* videos lazy loading */
// var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
// if (lazyVideos && "IntersectionObserver" in window) {
//     var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
//     entries.forEach(function(video) {
//         if (video.isIntersecting) {
//         for (var source in video.target.children) {
//             var videoSource = video.target.children[source];
//             if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
//             videoSource.src = videoSource.dataset.src;
//             if (video && video.playbackRate) {
//                 video.playbackRate = 0.5;
//             }
//             }
//         }

//         video.target.load();
//         video.target.classList.remove("lazy");
//         lazyVideoObserver.unobserve(video.target);
//         }
//     });
//     });

//     lazyVideos.forEach(function(lazyVideo) {
//     lazyVideoObserver.observe(lazyVideo);
//     });
// }


// let emailInput = document.querySelector('[type="email"]');
// if (emailInput && window['IMask']) {
//   let maskOptions = {
//     mask: '+{38}(000)000-00-00'
//   };
//   let mask = IMask(emailInput, maskOptions);
// }